import { render, staticRenderFns } from "./live_async.vue?vue&type=template&id=31ac526a&scoped=true"
import script from "./live_async.vue?vue&type=script&lang=js"
export * from "./live_async.vue?vue&type=script&lang=js"
import style0 from "./live_async.vue?vue&type=style&index=0&id=31ac526a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ac526a",
  null
  
)

export default component.exports